(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('morivia-upsell')) return;

    const DEFAULT_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

    const loadSwiper = (src) => {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (!window.__moriviaSwiperPromise) {
        window.__moriviaSwiperPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src || DEFAULT_SRC;
          script.async = true;
          script.onload = () => resolve(window.Swiper);
          script.onerror = () => {
            window.__moriviaSwiperPromise = null;
            reject(new Error('Swiper failed to load'));
          };
          document.head.appendChild(script);
        });
      }
      return window.__moriviaSwiperPromise;
    };

    class MoriviaUpsell extends HTMLElement {
      connectedCallback() {
        this._onChange = this._onChange || this._handleChange.bind(this);
        this.addEventListener('change', this._onChange);

        const track = this.querySelector('[data-upsell-track]');
        if (track) {
          this._mo = new MutationObserver(() => {
            clearTimeout(this._timer);
            this._timer = setTimeout(() => this.refresh(), 60);
          });
          this._mo.observe(track, { childList: true });
        }

        this.refresh();
      }

      disconnectedCallback() {
        this._token = (this._token || 0) + 1;
        clearTimeout(this._timer);
        this.removeEventListener('change', this._onChange);
        if (this._mo) this._mo.disconnect();
        this._destroySwiper();
      }

      async refresh() {
        const token = (this._token = (this._token || 0) + 1);
        const url = this.dataset.recsUrl;

        if (url) {
          try {
            const response = await fetch(url, { headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Recommendations request failed');
            const html = await response.text();
            if (token !== this._token) return;
            this._applyRemote(html);
          } catch (error) {
            if (token !== this._token) return;
            this._removeSkeleton();
          }
        }

        if (token !== this._token) return;
        await this._mount(token);
      }

      _removeSkeleton() {
        const track = this.querySelector('[data-upsell-track]');
        if (!track) return;
        track.querySelectorAll('.is-skeleton').forEach((node) => node.remove());
        if (this._mo) this._mo.takeRecords();
      }

      _applyRemote(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const remote = Array.from(doc.querySelectorAll('morivia-upsell')).find(
          (el) => el.dataset.instance === this.dataset.instance
        );
        const remoteTrack = remote && remote.querySelector('[data-upsell-track]');
        const track = this.querySelector('[data-upsell-track]');
        if (!track) return;

        if (!remoteTrack || !remoteTrack.querySelector('.morivia-upsell__slide')) {
          this._removeSkeleton();
          return;
        }

        this._destroySwiper();
        track.innerHTML = remoteTrack.innerHTML;
        if (this._mo) this._mo.takeRecords();
      }

      async _mount(token) {
        const track = this.querySelector('[data-upsell-track]');
        const hasSlides = !!track && !!track.querySelector('.morivia-upsell__slide:not(.is-skeleton)');
        this.hidden = !hasSlides;
        this._destroySwiper();
        if (!hasSlides) return;

        try {
          const Swiper = await loadSwiper(this.dataset.src);
          if (token !== this._token || !Swiper) return;

          const container = this.querySelector('[data-upsell-swiper]');
          const next = this.querySelector('[data-upsell-next]');
          const prev = this.querySelector('[data-upsell-prev]');
          const dots = this.querySelector('[data-upsell-dots]');
          const autoplay = parseFloat(this.dataset.autoplay) || 0;

          this._swiper = new Swiper(container, {
            slidesPerView: parseFloat(this.dataset.spv) || 1.2,
            spaceBetween: parseFloat(this.dataset.gap) || 0,
            speed: parseInt(this.dataset.speed, 10) || 400,
            rewind: this.dataset.rewind === 'true',
            watchOverflow: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            autoplay: autoplay
              ? { delay: autoplay * 1000, disableOnInteraction: false, pauseOnMouseEnter: true }
              : false,
            navigation:
              this.dataset.arrows === 'true' && next && prev
                ? { nextEl: next, prevEl: prev, disabledClass: 'is-disabled', lockClass: 'is-locked' }
                : false,
            pagination:
              this.dataset.dots === 'true' && dots
                ? {
                    el: dots,
                    clickable: true,
                    bulletClass: 'morivia-upsell__dot',
                    bulletActiveClass: 'is-active'
                  }
                : false
          });
        } catch (error) {
          console.warn('[morivia-upsell]', error);
        }
      }

      _destroySwiper() {
        if (this._swiper && !this._swiper.destroyed) this._swiper.destroy(true, true);
        this._swiper = null;
      }

      _handleChange(event) {
        const select = event.target.closest && event.target.closest('[data-variant-select]');
        if (!select) return;

        const card = select.closest('.morivia-upsell__card');
        const option = select.options[select.selectedIndex];
        if (!card || !option) return;

        const idInput = card.querySelector('input[name="id"]');
        if (idInput) idInput.value = select.value;

        const price = card.querySelector('[data-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;

        const compare = card.querySelector('[data-compare]');
        if (compare) {
          const value = option.dataset.compare || '';
          compare.textContent = value;
          compare.hidden = !value;
        }
      }
    }

    customElements.define('morivia-upsell', MoriviaUpsell);
  })();
  } catch(e) { console.error(e); }
})();

})();
